import styled from 'styled-components';

export const WrapperMonitoreo = styled.div`
  display: flex;

  @media screen and (max-width: 1134px) {
    flex-direction: column;
  }

  .devices-container {
    width: 25%;
    height: 65vh;
    overflow-y: auto;

    @media screen and (max-width: 1134px) {
      width: 100%;
    }
  }

  .standard-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (max-width: 1134px) {
      width: 100%;
    }
  }
`;

export const WrapperSecond = styled.button`
  display: flex;
  width: 100%;
`